const namespace = 'legal-compliance-business-rules';

export const GET_BUSINESS_RULES_VISIBLE_FIELDS = `${namespace}/Visible Fields Get`;
export const GET_BUSINESS_RULES_VISIBLE_FIELDS_SUCCESS = `${namespace}/Visible Fields Get Success`;
export const GET_BUSINESS_RULES_VISIBLE_FIELDS_FAIL = `${namespace}/Visible Fields Get Fail`;
